/**
 * Groups flat sections into category groups using isCategory/isFirstInCategory/category flags.
 *
 * Returns: [{ category, categoryId, categorySection?, sections }]
 * - categorySection: the isCategory section itself (if it has content)
 * - sections: child sections within the category
 *
 * If no sections have category data, returns a single group with all sections.
 */
export default function groupSectionsByCategory(sections) {
  if (!sections || sections.length === 0) return [];

  // Check if any sections have category info
  const hasCategories = sections.some(
    s => s.isCategory || s.isFirstInCategory || s.category
  );

  if (!hasCategories) {
    // No category data — return flat (single group, no header)
    return [{
      category: null,
      categoryId: 'all',
      categorySection: null,
      sections: sections,
    }];
  }

  const groups = [];
  let currentGroup = null;

  sections.forEach((section) => {
    if (section.isCategory || section.isFirstInCategory || !currentGroup) {
      currentGroup = {
        category: section.category || section.title,
        categoryId: section.isCategory ? section.id : `cat-${section.id}`,
        categorySection: section.isCategory && section.content ? section : null,
        sections: section.isCategory ? [] : [section],
      };
      groups.push(currentGroup);
    } else {
      currentGroup.sections.push(section);
    }
  });

  return groups;
}
